import { useState } from "react";
import { supabase } from "../lib/supabase";
import { toast } from "react-hot-toast"; // Using react-hot-toast for notifications
import { useNavigate } from "react-router-dom";

export default function AddUser() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	async function handleAddUser(e) {
		e.preventDefault();
		setLoading(true);

		try {
			// Create user using Supabase Auth
			const { data, error: signUpError } = await supabase.auth.signUp({
				email,
				password,
			});

			console.log("Sign-up response:", { data, signUpError }); // Log the response for debugging

			// Check if there was an error during sign-up
			if (signUpError) {
				toast.error("Error creating user: " + signUpError.message);
				setLoading(false);
				return;
			}

			if (!data || !data.user || !data.user.id) {
				toast.error("User authentication failed. Please try again.");
				setLoading(false);
				return;
			}

			const user = data.user; // Now, user is extracted from `data`

			// Check if the user profile exists
			const { data: profile, error: profileError } = await supabase
				.from("profiles")
				.select("role")
				.eq("id", user.id)
				.single(); // Use .single() to expect only one row

			// If profile doesn't exist, create one
			if (profileError && profileError.code !== "PGRST116") {
				toast.error(
					"Error fetching user profile: " + profileError.message
				);
				setLoading(false);
				return;
			}

			if (!profile) {
				// Create a profile for the user if it doesn't exist
				const { error: insertProfileError } = await supabase
					.from("profiles")
					.insert([
						{
							id: user.id,
							email: user.email,
							role: "user", // Explicitly setting the role as 'user'
						},
					]);

				if (insertProfileError) {
					toast.error(
						"Error creating profile: " + insertProfileError.message
					);
					setLoading(false);
					return;
				}
			}

			// Successfully created user and profile
			setEmail("");
			setPassword("");
			setLoading(false);
			toast.success("User created successfully.");
			navigate("/view-users");
		} catch (err) {
			toast.error("An error occurred while adding the user.");
			console.error(err);
			setLoading(false);
		}
	}

	return (
		<div className="main">
			<div className="add-user__wrapper">
				<h1>Add New User</h1>
				<form onSubmit={handleAddUser}>
					<div className="add-user__row">
						<label htmlFor="email">Email</label>
						<input
							type="email"
							id="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							required
						/>
					</div>
					<div className="add-user__row">
						<label htmlFor="password">Password</label>
						<input
							type="password"
							id="password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required
						/>
					</div>
					<button
						type="submit"
						disabled={loading}
						className="button green"
					>
						{loading ? "Creating..." : "Create User"}
					</button>
				</form>
			</div>
		</div>
	);
}
